// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import PipRequiredItem from '@deere/cps-it.warranty-model-factory/lib/pip-required-item';
import PipRequiredItemsList from './pip-required-items-list';

const PipRequiredItems = props => (
    <div className='pip-required-items'>
        <h3>
            <FormattedMessage id='REQUIRED_ITEMS'/>
        </h3>
        {props.requiredItems.length > 0 ? (
            <PipRequiredItemsList requiredItems={props.requiredItems}/>
        ) : (
            <FormattedMessage id='NO_REQUIRED_ITEMS'/>
        )}
    </div>
);

PipRequiredItems.displayName = 'PipRequiredItems';
PipRequiredItems.propTypes = {
    requiredItems: PropTypes.arrayOf(
        PropTypes.instanceOf(PipRequiredItem)
    ).isRequired
};

export default PipRequiredItems;



// WEBPACK FOOTER //
// ./src/pip/pip-details/components/pip-required-items.js